import { HttpMethods, makeRequest } from '../helpers/http.helper';
import { UtilityActivityType } from '../types/utility-emission.type';

interface GenericResponse<T> {
  result: T;
}

export async function listUtilityCatalog(): Promise<UtilityActivityType[]> {
  const response = (await makeRequest({
    url: '/esg/utility-emissions/catalog',
    method: HttpMethods.GET,
  })) as GenericResponse<UtilityActivityType[]>;
  return response.result;
}
